/** Deck's mark. It takes the text color, so it follows the theme. */
export function Mark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={(size * 21.8855) / 24} viewBox="0 0 24 21.8855" fill="none" role="img" aria-label="Deck">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M0 3.17183C9.18665e-06 1.4201 1.42009 6.63342e-07 3.17183 7.71783e-07L20.8282 0C22.5799 1.08441e-07 24 1.4201 24 3.17183V18.7137C24 20.4654 22.5799 21.8855 20.8282 21.8855L3.17183 21.8855C1.42009 21.8855 7.74043e-06 20.4654 6.79356e-07 18.7137L0 3.17183ZM3.56529 15.4539C3.56529 17.3142 4.4017 18.1229 6.54485 18.123H9.94256C17.0516 18.123 20.6062 15.6561 20.6062 10.7627C20.6062 7.97227 19.4563 5.90973 16.9994 4.69648C14.4381 3.4428 13.079 3.44278 6.44041 3.44278C4.50631 3.44278 3.56529 4.21114 3.56529 5.74792L3.56529 15.4539Z"
      />
    </svg>
  );
}
